import React, { useEffect, useRef, useState } from 'react';
import {
    Navbar,
    Container,
    Button,
    Nav,
    NavDropdown,
} from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaHandsHelping } from 'react-icons/fa';
import { getAuthProvider } from '../../containers/auth/azureAuthProvider';
import { StringEncryption } from '../../utils';
import axios from 'axios';
import brandLogo from '../../assets/icons/Agilisium new logo .png';

import Styles from './navbar.module.scss'
import { trackEvent } from '../../utils/gaTracking';

function Navigationbar({ hubId }) {
    const [show, setShow] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [helpText, setHelpText] = useState('');

    const [activeDropdown, setActiveDropdown] = useState(null);

    const helpRef = useRef(null);
    const btnRef = useRef(null);
    const authState = useSelector((state) => state.authUser);
    const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);
    const user_id = authState?.profile?.user_id;
    const user_email = authState?.profile?.email;

    const sendMail = async (content) => {
        try {
            const accessToken = await (await getAuthProvider().getAccessToken()).accessToken;
            const encryptToken = StringEncryption(accessToken);
            const data = {
                from: authState?.profile?.email,
                to: 'hr@agilisium.com',
                subject: 'Help center',
                desc: content,
                accesToken: encryptToken,
            };
            await axios.post(`${process.env.REACT_APP_API_DOMAIN}/api/helpcenter/sent-email`, data);
            setHelpText('');
            setShowHelp(false);
            trackEvent('help_center_qurey_raised', 'Help Center Qurey Raised', 'Help Center Qurey Raised', 1, user_id, user_email);
        } catch (error) {
            console.error("Error sending email:", error);
        }
    };

    // Close Help Center when clicking outside
    const handleClickOutside = (event) => {
        if (helpRef.current && !helpRef.current.contains(event.target) && btnRef.current && !btnRef.current.contains(event.target)) {
            setShowHelp(false);
        }
    };

    const handleClose = (dropdown) => {
        setShow(false);
        setActiveDropdown(dropdown);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Navbar expand="lg" className="bg-body-tertiary p-0 fixed-top" style={{ zIndex: 999 }}>
            <Container fluid className="bg-white p-1 border border-gray-400 ">
                {/* People Hub Logo */}
                <Navbar.Brand className="brand">
                    <img
                        src={brandLogo}
                        alt="brand"
                        style={{ height: '58px', opacity: '1'}}
                    />
                </Navbar.Brand>

                {/* Navbar Toggle Button */}
                <Navbar.Toggle aria-controls="navbarScroll" onClick={() => setShow(!show)} />

                <Navbar.Collapse id="navbarScroll">
                    {/* Add Navbar Items Here */}
                    {(hasRole(6) || hasRole(10)) &&<Nav.Link
                        as={NavLink}
                        to="/"
                        className={`px-4 ${Styles.navHeader} ${activeDropdown === 'home' ? 'active' : ''}`}
                        onClick={() => handleClose('home')}
                    >
                        Home
                    </Nav.Link>}
                    {(hasRole(6) || hasRole(10)) && <NavDropdown
                        title={hasRole(6) ? "Super Admin" : "Admin"}
                        id="navbarScrollingDropdown"
                        className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                    >
                        <NavDropdown.Item
                            as={NavLink}
                            to="/manageFlashnews"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Flash News
                        </NavDropdown.Item>
                        <NavDropdown.Divider className='divider' />
                        <NavDropdown.Item
                            as={NavLink}
                            to="/manageagilisiumcorner"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Agilisium Corner
                        </NavDropdown.Item>
                        <NavDropdown.Divider className='divider' />
                        <NavDropdown.Item
                            as={NavLink}
                            to="/managethoughtleadership"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Thought Leadership
                        </NavDropdown.Item>
                        {/* <NavDropdown.Divider className='divider' />
                        <NavDropdown.Item
                            as={NavLink}
                            to="/manageHomeGallery"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Gallery
                        </NavDropdown.Item> */}
                        
                        <NavDropdown.Divider className='divider'/>
                        <NavDropdown.Item
                            as={NavLink}
                            to="/managehubspoc"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Hub SPOC
                        </NavDropdown.Item>
                        { hasRole(6) && <>
                        <NavDropdown.Divider className='divider' />
                        <NavDropdown.Item
                            as={NavLink}
                            to="/users"
                            className="bg-transparent menulink"
                            onClick={() => handleClose('admin')}
                        >
                            Manage Users
                        </NavDropdown.Item>
                        </>}
                    </NavDropdown>}
                </Navbar.Collapse>

                {/* Help Center Button */}
                <Button
                    variant="outline-light"
                    className=" backtohomebtn me-2"
                    onClick={() => setShowHelp(true)}
                    ref={btnRef}
                >
                    Help Center <FaHandsHelping size={20} />
                </Button>

                {/* Help Center Popover */}
                {showHelp && (
                    <div id="popoverContent" className="popover-content p-3 rounded shadow-sm bg-light" ref={helpRef}>
                        <p className="mb-2">Write your troubleshooting questions to our expertise.</p>
                        <textarea
                            className="form-control mb-2"
                            rows="4"
                            maxLength="200"
                            value={helpText}
                            onChange={(e) => setHelpText(e.target.value)}
                        ></textarea>
                        <div className="d-flex justify-content-end">
                            <Button variant="secondary" className="me-2" onClick={() => setShowHelp(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" disabled={!helpText} onClick={() => sendMail(helpText)}>
                                Send
                            </Button>
                        </div>
                    </div>
                )}

                {/* Brand Logo */}

            </Container>
        </Navbar>
    );
}

export default Navigationbar;
